import api from './api';

const annotationsService = {
  getAnnotations: async () => {
    try {
      const response = await api.get('/annotations');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar anotações:', error);
      throw error;
    }
  },

  createAnnotation: async (data) => {
    try {
      const response = await api.post('/annotations', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar anotação:', error);
      throw error;
    }
  },

  updateAnnotation: async (id, data) => {
    try {
      const response = await api.put(`/annotations/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar anotação:', error);
      throw error;
    }
  },

  deleteAnnotation: async (id) => {
    try {
      const response = await api.delete(`/annotations/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar anotação:', error);
      throw error;
    }
  },
};

export default annotationsService;